import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { SellerAuthProvider } from './context/SellerAuthContext.js';
import { ProductProvider } from './context/ProductContext.js';
import { ThemeProvider } from './context/ThemeContext.js';
import { App } from './App.js';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

createRoot(rootEl).render(
  <BrowserRouter basename="/register">
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <SellerAuthProvider>
          <ProductProvider>
            <App />
            <Toaster position="top-right" richColors closeButton />
          </ProductProvider>
        </SellerAuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </BrowserRouter>,
);
